import React from 'react';
import OrderStatus from '../Status/OrderStatus';
import ItemDescriptionView from '../../item/ItemDescriptionView';
import OrderResultButton from '../Result/OrderResultButton';
import AffiliateOrderGuide from '../Result/AffiliateOrderGuide';

import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import VoucherOrderResultButton from '../Result/VoucherOrderResultButton';
import { IMG_SALES_ITEM } from '../../../lib/image/ServiceImages';

const OrderDetailShortForm = ({ order }) => {
  const { id, items } = order;
  const { voucher } = items[0];

  return (
    <>
      <ShortForm order={order} />
      {voucher ? (
        <VoucherOrderResultButton id={id} item={items[0]} />
      ) : (
        <OrderResultButton id={id} item={items[0]} />
      )}
      <AffiliateOrderGuide item={items[0]} />
    </>
  );
};

export default React.memo(OrderDetailShortForm);

export const ShortForm = ({ order }) => {
  const { description, items } = order;
  const {
    status,
    code,
    additionalInfo: { recipientName },
    voucherType,
    voucher,
  } = items[0];

  const isPrePurchaseOrder = voucherType === 'PRE_ORDER';
  return (
    <Flex padding="1.25rem 0">
      <img src={IMG_SALES_ITEM} width="25%" height="100%" alt="" />
      <Flex column alignItems="flex-start" padding="0 0 0 1.25rem" width="75%">
        <Text size={14} weight="medium">
          베이비페이스{' '}
          {voucher && (isPrePurchaseOrder ? '사전 구매' : '선물하기')}
        </Text>
        <ItemDescriptionView descriptions={description} items={items[0]} />
        {voucher && (
          <Text size={12} color="orangePink" lineHeight={1.5}>
            {isPrePurchaseOrder ? '사전 구매 쿠폰 코드 : ' : 'To. '}

            <Text size={12}>{isPrePurchaseOrder ? code : recipientName}</Text>
          </Text>
        )}
        <OrderStatus isVoucher={voucher} status={status} />
      </Flex>
    </Flex>
  );
};
